// test2959
(2959 && 0);
